import React from 'react';

export type ToggleCardContentProps = {
    children?: React.ReactNode | React.ReactNode[];
    contentId: string;
};

const ToggleCardContent: React.FC<ToggleCardContentProps> = (props) => {
    const { children, contentId } = props;

    return (
        <div className="toggle-card-content">
            <div className="toggle-card-content__inner" id={contentId}>
                {children}
            </div>
        </div>
    );
};

export default ToggleCardContent;
